import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { StockReplenishmentRunOrderFulfillmentLineModel } from "../../../../../../models/aggregates/erp/stock/stock-replenishment-run-order-fullfillment-line.model";
import { Observable } from "rxjs";
import { ApiVisa, ApiResponseModel } from "../../shared";

@Injectable({ providedIn: "root" })
export class StockReplenishmentRunOrderFulfillmentLineService extends BaseApiTemplateService<StockReplenishmentRunOrderFulfillmentLineModel> {
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "stock-replenishment-run-order-fulfillment-lines/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "stock-replenishment-run-order-fulfillment-lines/backoffice-ep";
    this.httpClient = theHttp;
  }

  generatePO(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        "stock-replenishment-run-order-fulfillment-lines/generate-purchase-order/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
